// extracted by mini-css-extract-plugin
module.exports = {"buttonPrimary":"Button_buttonPrimary__qv9A5","buttonSecondary":"Button_buttonSecondary__2ljB4"};